export default __webpack_public_path__ + "static/media/JU-uITLA.7af2413b.png";